import './chatbotResponseMsg.css';
import Typing from "../../../../shared/typing";
import {cn} from "../../../../../utils/utils";
import {useEffect, useState} from "react";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSanitize from 'rehype-sanitize';

const ChatbotResponseMsg = ({msg, isGenerating, isThinking, isLast, thinkingText = "Firulais está pensando "}) => {
    // Texto que se va mostrando poco a poco
    const [displayText, setDisplayText] = useState('');

    // Renderizado progresivo cuando se está generando
    useEffect(() => {
        if (isThinking) return;

        if (isGenerating && msg?.text) {
            let currentText = displayText;
            const newText = msg.text.slice(currentText.length);
            let i = 0;

            const t = setInterval(() => {
                i++;
                setDisplayText(prev => prev + newText.slice(prev.length - currentText.length, i));
                if (i >= newText.length) clearInterval(t);
            }, 15);

            return () => clearInterval(t);
        } else {
            setDisplayText(msg?.text ?? '');
        }
    }, [msg?.text, isGenerating, isThinking]);

    // Scroll / altura (tu lógica original)
    useEffect(() => {
        const parentContainer = document.querySelector('.chat-container__chat');
        const lastQuestion = document.querySelector('.chatbot-user-msg.last-user-msg');

        if (parentContainer && lastQuestion) {
            parentContainer.style.setProperty(
                '--lastResponseHeight',
                `${parentContainer.clientHeight - lastQuestion.clientHeight - 60}px`
            );
            parentContainer.scrollTo({top: parentContainer.scrollHeight, behavior: 'smooth'});
        }
    }, []);

    // Bloque de thinking (igual que antes)
    if (isThinking) {
        return (
            <div className={cn("chatbot-response-msg thinking", {"last-response": isLast})}>
        <span>
          <i className="fa-solid fa-bone fa-spin"></i>
          <Typing
              className="typing-italic"
              style={{marginLeft: '10px', display: 'inline-block'}}
              text={thinkingText + "..."}
              secondaryText={thinkingText}
          />
        </span>
            </div>
        );
    }

    // Render Markdown de forma segura y progresiva
    return (
        <div
            className={cn(
                "chatbot-response-msg",
                {"generating": isGenerating},
                {"last-response": isLast},
                {"error-response": msg?.error}
            )}
        >
      <span>
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeSanitize]}
        >
          {displayText}
        </ReactMarkdown>
      </span>
        </div>
    );
};

export default ChatbotResponseMsg;
